import React from 'react';

function CompanyDashboard() {
    return (
        <div className='CompanyDashboard'>
            <h1>Company Dashboard</h1>
            <p>Welcome, company admin! This is your dashboard.</p>
        </div>
    );
}

export default CompanyDashboard;
